import type { TFunction } from 'i18next';

import type { PageAlertConfig } from '../../types/page-alerts.ts';

export type DepartureAlertPageData =
  | {
      variant: 'departure';
      childName?: string;
      count: number;
    }
  | {
      variant: 'sub';
      departedChildName?: string;
      count: number;
    };

export const getDeparturePageAlert = ({
  id,
  alertData,
  t,
}: {
  id: string;
  alertData: DepartureAlertPageData;
  t: TFunction<'my', undefined>;
}): PageAlertConfig => {
  if (alertData.variant === 'sub') {
    return {
      id,
      priority: 100,
      variant: 'warning',
      title: t('my:sponsorshipRelationship.departures.alert.sub.title', {
        childName: alertData.departedChildName,
        count: alertData.count,
      }),
      message: t('my:sponsorshipRelationship.departures.alert.sub.message', {
        childName: alertData.departedChildName,
        departedChildName: alertData.departedChildName,
        count: alertData.count,
      }),
    };
  }

  return {
    id,
    priority: 100,
    variant: 'warning',
    title: t('my:sponsorshipRelationship.departures.alert.departure.title', {
      childName: alertData.childName,
      count: alertData.count,
    }),
    message: t(
      'my:sponsorshipRelationship.departures.alert.departure.message',
      {
        childName: alertData.childName,
        count: alertData.count,
      },
    ),
  };
};
